import React from 'react'

const CheckoutSectionHeader = ({ label }) => (
  <header><h4 style={{ color: '#000'}}>{label}</h4></header>
)

export default CheckoutSectionHeader